var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('landing-create', {
    attrs: {
      "content": _vm.landingContent
    }
  }), _vm.surveyForm ? _c('survey-form', {
    attrs: {
      "isLoading": _vm.isLoading,
      "surveyForm": _vm.surveyForm,
      "onSubmit": _vm.onSubmit,
      "onExport": _vm.onExport
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }